<template>
  <div class="edit">
    <div class="edit-content">
      <div v-for="(ele, index) in editForm.formProps[0].formProps" :key="index">
        <template v-if="ele.label == '报销金额'">
          <div class="edit-item">
            <div class="title">报销金额</div>
            <el-input
              v-model="ele.defaultValue"
              placeholder="请输入金额"
            ></el-input>
          </div>
        </template>
        <template v-if="ele.label == '报销类别'">
          <div class="edit-item">
            <div class="title">报销类别</div>
            <el-input
              v-model="ele.defaultValue"
              placeholder="请输入内容"
            ></el-input>
          </div>
          <div class="edit-item" v-if="ele.propOptions">
            <div class="title">选项</div>
            <div
              class="select edit-item2"
              v-for="(item, idx) in ele.propOptions"
              :key="idx"
            >
              <i class="iconfont icon-xuanxiang"></i>
              <el-input
                v-model="item.defaultValue"
                placeholder="请输入内容"
              ></el-input>
              <span @click="removeSelect(idx)"
                ><i class="el-icon-delete"></i
              ></span>
            </div>
            <div class="addedit">
              <!-- <span @click="batchClick">批量编辑</span> -->
              <span @click="addSelect">添加选项</span>
            </div>
          </div>
        </template>
        <template v-if="ele.label == '费用明细'">
          <div class="edit-item">
            <div class="title">费用明细</div>
            <el-input
              v-model="ele.defaultValue"
              placeholder="请输入金额"
            ></el-input>
          </div>
        </template>
      </div>
      <div class="title" style="font-size: 16px; margin-bottom: 10px">必填</div>
      <div v-for="ele in editForm.formProps[0].formProps" :key="ele.label">
        <template v-if="ele.label == '报销类别'">
          <div class="edit-item">
            <div class="title">报销类别</div>
            <el-switch
              v-model="ele.required"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </div>
        </template>
        <template v-if="ele.label == '费用明细'">
          <div class="edit-item">
            <div class="title">费用明细</div>
            <el-switch
              v-model="ele.required"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    editForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  methods: {
    batchClick() {
      this.$emit("batchClick", 1);
    },
    addSelect() {
      this.$emit("addSelect", 1);
    },
    removeSelect(index) {
      this.$emit("removeSelect", index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.draggable-none {
  // margin: 42px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 42px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  color: #999999;
  img {
    margin-right: 16px;
  }
}
.edit-none {
  height: 100%;
  color: #999999;
  position: relative;
  span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.edit-number {
  width: 100%;
  line-height: 40px;
  background-color: #ffeeee;
  color: #d43030;
  font-size: 12px;
  text-align: center;
  margin-bottom: 16px;
}
.edit-title {
  color: #0f66f2;
  margin-bottom: 24px;
  .iconfont {
    margin-right: 8px;
  }
}
.edit-column {
  text-align: center;
  margin: 35% 0 0;
  color: #999999;
  div {
    line-height: 36px;
  }
}
.addedit {
  padding: 12px 0;
  color: #0f66f2;
  span {
    padding: 0 8px;
    cursor: pointer;
    &:nth-of-type(1) {
      border-right: 1px solid #eeeeee;
    }
  }
}
.edit-item {
  margin-bottom: 16px;
  .title {
    margin-bottom: 12px;
    span {
      font-size: 12px;
      color: #999;
    }
    i {
      font-style: normal;
      color: #0f66f2;
    }
  }
}
.edit-item2 {
  margin-bottom: 12px;
}
.edit-have {
  height: 100%;
}
.edit-item-list {
  margin-bottom: 8px;
}
.edit-ul {
  width: 80%;
  margin: 16px auto;
  li {
    display: flex;
    padding: 6px;
    border: 1px solid #eeeeee;
    div {
      width: 50%;
      text-align: center;
      &:nth-of-type(1) {
        border-right: 1px solid #eeeeee;
      }
    }
  }
}
</style>
